import { render } from "./ModalAgree.vue?vue&type=template&id=bd023608&scoped=true"
import script from "./ModalAgree.vue?vue&type=script&lang=js"
export * from "./ModalAgree.vue?vue&type=script&lang=js"

import "./ModalAgree.vue?vue&type=style&index=0&id=bd023608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd023608"]])

export default __exports__